module.exports = __webpack_public_path__ + "img/川牛膝.f394c86c.jpg";